import getItem from './getItem';

export default getItem;
